
import { defineComponent } from 'vue';

import FormField from '@/components/forms/FormField.vue';

/**
 * TODO:
 *
 * Recreate this component when the backend start creating auto-generated
 * passwords
 */

export default defineComponent({
  name: 'roles-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      type: String,
      default: 'col-lg-4',
    },
    name: {
      type: String,
      default: 'roles',
    },
    label: {
      type: String,
      default: 'Role',
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: null,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },
  },
});
